import { Col, Form, Input, Radio, Row, Select, Spin, Tabs, Divider, Checkbox } from 'antd';
import * as _ from 'lodash';
import * as React from 'react';
import { Subscribe } from 'unstated';
// @ts-ignore
import * as webalize from 'webalize';

import CategoriesQuery from '../../../../components/Query/Categories';
import Manufacturers from '../../../../components/Query/Manufacturers';
import Suppliers from '../../../../components/Query/Suppliers';
import { debounceRate } from '../../../../config/config';
import StateContainer from '../StateContainer';
import CategoriesSelect from './CategoriesSelect';
import GetProductTagsQuery from '../../../../components/Query/ProductTags';
import PricesWithDiscountInput from '../../../../components/Others/PricesWithDiscountInput';
import { AvailabilitySelect } from 'src/scenes/Availabilities';
import { getPrivilegesTo } from 'src/helpers/Users/getPrivilegesTo';
import { privileges } from 'data-layer/src/services/Users/privileges';
import DiscountInput from 'src/components/Others/DiscountInput';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { isNewProduct } from '../ProductDetail';
import ExternalBlogTagSelect from '../../../../components/Others/ExternalBlogTagSelect';
import CustomerGroupSelect from 'src/components/Others/CustomerGroupSelect';

export interface IGeneralSettingsTabProps {
  domain: string;
  container: StateContainer;
  shouldUpdate: boolean;
}

const changeSlugAutomatically = (product: GQL.IProduct, language: string) => isNewProduct(product);

export class GeneralSettingsTab extends React.Component<IGeneralSettingsTabProps> {

  constructor(props: IGeneralSettingsTabProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onChange = _.debounce(this.onChange, debounceRate);

    this.onChangeMany = this.onChangeMany.bind(this);
    this.onChangeMany = _.debounce(this.onChangeMany, debounceRate);
  }

  public shouldComponentUpdate() {
    return this.props.shouldUpdate;
  }

  public render() {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px'
    };

    const { container } = this.props;
    const restrictFromCatalog = container.state.product.variants == undefined || container.state.product.variants.length == 0;

    const privilegesToPrices = getPrivilegesTo(privileges.CHANGE_PRODUCT_PRICE);
    return (
      <Subscribe to={[container]}>
        {productDetail => (
          <Row gutter={72} className={'ant-form'}>
            <Col md={16}>
              <Row gutter={16}>
                <Col md={8}>
                  <Form.Item
                    validateStatus={this.validateStatus('title')}
                    help={this.validateMessage('title')}
                    label={'Title'}
                    required={true}
                  >
                    <Input
                      name={'title'}
                      autoFocus={true}
                      placeholder="Internal title. For example &quot;Air Jordan&quot;"
                      addonBefore={'Internal'}
                      defaultValue={productDetail.state.product.title}
                      onChange={e => {
                        this.onChange('title', e.target.value, true);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item
                    validateStatus={this.validateStatus('name')}
                    help={this.validateMessage('name')}
                    label={'Name - ' + container.state.currentLanguage}
                    required={true}
                  >
                    <Input
                      key={container.state.currentLanguage}
                      name={'name'}
                      addonBefore={container.state.currentLanguage}
                      placeholder="Product's name in the eshop"
                      defaultValue={productDetail.state.product.name[container.state.currentLanguage]}
                      onChange={e => {
                        if (
                          changeSlugAutomatically(productDetail.state.product, container.state.currentLanguage)
                        ) {
                          this.onChangeMany([
                            {
                              key: 'name',
                              val: e.target.value,
                              validate: true,
                              language: container.state.currentLanguage
                            },
                            {
                              key: 'slug',
                              validate: false,
                              val: webalize.webalize(e.target.value),
                              language: container.state.currentLanguage
                            }
                          ]);
                        } else {
                          this.onChange('name', e.target.value, true, container.state.currentLanguage);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item
                    validateStatus={this.validateStatus('sku')}
                    help={this.validateMessage('sku')}
                    label={'Item number'}
                  >
                    <Input
                      name="sku"
                      placeholder="Item number"
                      defaultValue={productDetail.state.product.sku}
                      onChange={e => this.onChange('sku', e.target.value, true)}
                    />
                  </Form.Item>
                </Col>

                <Col md={8}>
                  <Form.Item
                    label={'Subtitle - ' + container.state.currentLanguage}
                    validateStatus={this.validateStatus('subtitle')}
                    help={this.validateMessage('subtitle')}
                    required={false}
                  >
                    <Input
                      key={container.state.currentLanguage}
                      name={'subtitle'}
                      addonBefore={container.state.currentLanguage}
                      placeholder="Optional subtitle"
                      defaultValue={productDetail.state.product.subtitle[container.state.currentLanguage]}
                      onChange={e => {
                        this.onChange('subtitle', e.target.value, true, container.state.currentLanguage);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item
                    label={'Slug - ' + container.state.currentLanguage}
                    required={false}
                    validateStatus={this.validateStatus('slug')}
                    help={this.validateMessage('slug')}
                  >
                    <Input
                      key={container.state.currentLanguage}
                      name={'slug'}
                      addonBefore={container.state.currentLanguage}
                      value={productDetail.state.product.slug[container.state.currentLanguage]}
                      disabled={true}
                      onChange={e => {
                        // slug je disabled, takže onChange se neaplikuje
                        // this.onChange('slug', e.target.value, true, container.state.currentLanguage);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <AvailabilitySelect
                    name="availabilityId"
                    label="Availability"
                    value={container.state.product.availabilityId || undefined}
                    placeholder="Availability"
                    onChange={e => {
                      this.onChange('availabilityId', e.target.value, false);
                    }}
                  />
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={7}>
                  <Form.Item
                    label={'Recommended price (excl. vat)'}
                    validateStatus={this.validateStatus('recommendedPrice')}
                    help={this.validateMessage('recommendedPrice')}
                  >
                    <PricesWithDiscountInput
                      ean={undefined}
                      sku={undefined}
                      name={'prices'}
                      disabled={true}
                      mode={'recommendedPriceWithout'}
                      availabilityMode={true}
                      stockMode={false}
                      prices={productDetail.state.product.prices.map((price: GQL.IPrice) => ({...price}))}
                      onChange={(e) => this.onChange('prices', e.target.value, false)}
                    />
                  </Form.Item>
                </Col>
                <Col md={4}>
                  <Form.Item
                    label={'Discount'}
                    validateStatus={this.validateStatus('discount')}
                    help={this.validateMessage('discount')}
                  >
                    <DiscountInput
                      disabled={true}
                      name={'prices'}
                      prices={productDetail.state.product.prices.map((price: GQL.IPrice) => ({...price}))}
                      onChange={(e: any) => this.onChange('prices', e.target.value, false)}
                    />
                  </Form.Item>
                </Col>
                <Col md={6}>
                  <Form.Item
                    label={'Minimal price (with discount)'}
                  >
                    <PricesWithDiscountInput
                      sku={undefined}
                      ean={undefined}
                      name={'prices'}
                      disabled={true}
                      mode={'minimalPrice'}
                      availabilityMode={true}
                      prices={productDetail.state.product.prices.map((price: GQL.IPrice) => ({...price}))}
                      onChange={(e) => {
                        this.onChange('prices', e.target.value, false);
                      }}
                    />                        
                  </Form.Item>
                </Col>
                <Col md={7}>
                  <Form.Item
                    label={'Price (excl. vat)'}
                    validateStatus={this.validateStatus('price')}
                    help={this.validateMessage('price')}
                  >
                    <PricesWithDiscountInput
                      sku={undefined}
                      ean={undefined}
                      name={'prices'}
                      disabled={true}
                      mode={'priceWithout'}
                      availabilityMode={true}
                      stockMode={false}
                      prices={productDetail.state.product.prices.map((price: GQL.IPrice) => ({...price}))}
                      onChange={(e: any) => this.onChange('prices', e.target.value, false)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={9}>
                  <Form.Item
                    label={'Customer discounts'}
                  >
                    <Checkbox
                      name={'neverApplyCustomerDiscounts'}
                      value={1}
                      checked={container.state.product.neverApplyCustomerDiscounts ? true : false}
                      onChange={(e: any) => { this.onChange('neverApplyCustomerDiscounts', e.target.checked, false) }}>
                      Never apply customer discounts
                      </Checkbox>
                  </Form.Item>
                </Col>
                <Col md={9}>
                  <Form.Item
                    label={'Discount to apply to this product'}
                  >
                   <CustomerGroupSelect
                      name={'discountGroupOnly'}
                      value={container.state.product.customerGroupsOnlyDiscountIds || []}
                      mode="multiple"
                      onChange={(e: any) =>  { this.onChange('customerGroupsOnlyDiscountIds', e.target.value.map(c => c.id), false)}}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={12}>
                  <Manufacturers>
                    {({ manufacturers }: any) => {
                      if (manufacturers.loading) {
                        return (
                          <div>
                            <Spin /> Loading manufacturers ...
                          </div>
                        );
                      }

                      return (
                        <Form.Item
                          label={'Manufacturer'}
                          required={true}
                          validateStatus={this.validateStatus('manufacturer')}
                          help={this.validateMessage('manufacturer')}
                        >
                          <Select
                            showSearch={true}
                            style={{ width: '100%' }}
                            onChange={(value: string) => container.onChange('manufacturerId', value, false)}
                            placeholder="Select manufacturer"
                            defaultValue={
                              (productDetail.state.product.manufacturer || {}).id
                              // tslint:disable-next-line:jsx-curly-spacing
                            }
                          >
                            {(manufacturers.manufacturers || []).map((m: GQL.IManufacturer) => {
                              return (
                                <Select.Option key={m.id} value={m.id}>
                                  {m.name}
                                </Select.Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      );
                    }}
                  </Manufacturers>
                </Col>
              </Row>

              <Row>
                <Col md={24}>
                  <Form.Item
                    validateStatus={this.validateStatus('perex')}
                    help={this.validateMessage('perex')}
                    label={'Perex - ' + container.state.currentLanguage}
                  >
                    <ReactQuill
                      key={container.state.currentLanguage}
                      placeholder="Type short introduction of product..."
                      value={productDetail.state.product.perex[container.state.currentLanguage] || ''}
                      onChange={value => this.onChange('perex', value, true, container.state.currentLanguage)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col md={24}>
                  <Form.Item
                    label={'Description - ' + container.state.currentLanguage}
                    validateStatus={this.validateStatus('description')}
                    help={this.validateMessage('description')}
                  >
                    <ReactQuill
                      key={container.state.currentLanguage}
                      placeholder="Type information about product..."
                      defaultValue={productDetail.state.product.description[container.state.currentLanguage] || ''}
                      onChange={v =>
                        this.onChange('description', v, true, container.state.currentLanguage)
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col md={24}>
                  <Form.Item
                    label={'Technical specification - ' + container.state.currentLanguage}
                    required={false}
                    validateStatus={this.validateStatus('technicalSpecification')}
                    help={this.validateMessage('technicalSpecification')}
                    extra={'Put each value on a separate line'}
                  >
                    <ReactQuill
                      key={container.state.currentLanguage}
                      placeholder="Technical specs of a product"
                      value={
                        productDetail.state.product.technicalSpecification[container.state.currentLanguage] || ''
                      }
                      onChange={v =>
                        this.onChange(
                          'technicalSpecification',
                          v,
                          true,
                          container.state.currentLanguage
                        )
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col md={14}>
                  <Form.Item label={'Visual tags'}>
                    <GetProductTagsQuery
                      domain={this.props.domain}
                    >
                      {({ productTags }: any) => (
                        <Select
                          mode="tags"
                          defaultValue={productDetail.state.product.tags}
                          style={{ width: '100%' }}
                          placeholder="Type tags"
                          onChange={(tags: string[]) => this.onChange('tags', tags, false)}
                        >
                          {productTags && productTags.productTags &&
                            productTags.productTags.map((t: GQL.IProductTag) => (
                              <Select.Option key={t.id} value={t.id} style={{ position: 'relative', backgroundColor: t.color || 'transparent', color: '#FFF' }}>
                                <span style={{ zIndex: 2, position: 'relative', color: '#FFF', fontSize: '90%', fontWeight: 500 }}>{t.name}</span>
                                <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: t.color || 'transparent', color: '#FFF' }} />
                              </Select.Option>
                            ))}
                        </Select>
                      )}
                    </GetProductTagsQuery>
                  </Form.Item>
                </Col>
                <Col md={5}>
                  <Form.Item
                    validateStatus={this.validateStatus('weight')}
                    help={this.validateMessage('weight')}
                    label={'Weight'}
                    required={false}
                  >
                    <Input
                      name="weight"
                      placeholder="Weight"
                      type={'number'}
                      defaultValue={productDetail.state.product.weight}
                      addonAfter={'gr.'}
                      onChange={e => this.onChange('weight', e.target.value, true)}
                    />
                  </Form.Item>
                </Col>
                <Col md={5}>
                  <Form.Item
                    validateStatus={this.validateStatus('weightForShipping')}
                    help={this.validateMessage('weightForShipping')}
                    label={'Weight for shipping'}
                  >
                    <Input
                      name="weightForShipping"
                      placeholder="Weight for shipping"
                      type={'number'}
                      defaultValue={productDetail.state.product.weightForShipping}
                      addonAfter={'gr.'}
                      onChange={e => this.onChange('weightForShipping', e.target.value, false)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col md={14}>
                  <Form.Item label={'Blog tags'}>
                    <ExternalBlogTagSelect
                      name="externalBlogTags"
                      tags={productDetail.state.product.externalBlogTags || []}
                      onChange={this.onChange}
                    />
                  </Form.Item>
                </Col>
                <Col md={5}>
                  <Form.Item
                    label={'Show blog articles'}
                    required={false}
                  >
                    <Input
                      name="externalBlogArticleNumber"
                      placeholder="Count"
                      type={'number'}
                      defaultValue={productDetail.state.product.externalBlogArticleNumber}
                      min={0}
                      max={255}
                      onChange={e => this.onChange('externalBlogArticleNumber', e.target.value, false)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col md={8}>
              <Form.Item label={`Meta title`}>
                <Input
                  name={'metaTitle'}
                  placeholder="Meta title (SEO)"
                  addonBefore={container.state.currentLanguage}
                  defaultValue={(container.state.product.metaTitle || {})[container.state.currentLanguage]}
                  required={false}
                  onChange={e =>
                    this.onChange('metaTitle', e.target.value, true, container.state.currentLanguage)
                  }
                />
              </Form.Item>
              <Form.Item label={`Meta description - ${container.state.currentLanguage}`}>
                <Input.TextArea
                  name={'metaDescription'}
                  placeholder="Describe category without links and maximum length 160 characters here"
                  defaultValue={(container.state.product.metaDescription || {})[container.state.currentLanguage]}
                  onChange={e =>
                    this.onChange('metaDescription', e.target.value, true, container.state.currentLanguage)
                  }
                />
              </Form.Item>

              <Form.Item
                label={'Categories'}
                help={
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <i>Product attributes are based on categories assocation.</i>
                  </span>
                }
              >
                <CategoriesQuery cache={false} search={''}>
                  {(categories: any) => {
                    if (categories.loading || !categories.categories || !categories.categories.categories) {
                      return (
                        <div>
                          <Spin /> Loading categories ...
                        </div>
                      );
                    }

                    const productCategories = productDetail.state.product.categories as Array<GQL.ICategory>;

                    const groupedByEshop = _.groupBy(categories.categories.categories, c => {
                      return c.eshop.id;
                    });

                    return (
                      <Tabs>
                        {Object.keys(groupedByEshop).map(eshopId => {
                          return (
                            <Tabs.TabPane key={eshopId} tab={groupedByEshop[eshopId][0].eshop.name}>
                              <CategoriesSelect
                                onChange={checked =>
                                  this.updateCategories(
                                    checked,
                                    productCategories,
                                    categories.categories.categories,
                                    eshopId
                                  )
                                }
                                categories={groupedByEshop[eshopId]}
                                selectedCategories={productCategories}
                                key={eshopId}
                              />
                            </Tabs.TabPane>
                          );
                        })}
                      </Tabs>
                    );
                  }}
                </CategoriesQuery>
              </Form.Item>
              <Divider />
              <Form.Item
                label={'Display?'}
                extra={restrictFromCatalog ? 'You need at least 1 product variant' : undefined}
                required={false}
              >
                <Radio.Group
                  onChange={e => container.onChange('displayStatus', e.target.value, false)}
                  value={productDetail.state.product.displayStatus}
                >
                  <Radio style={radioStyle} disabled={restrictFromCatalog} value={2}>
                    Yes, display in catalog
                  </Radio>
                  <Radio style={radioStyle} disabled={restrictFromCatalog} value={1}>
                    No, hide from catalog (search), detail is available
                  </Radio>
                  <Radio style={radioStyle} value={0}>
                    Completely hidden
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label={'Out of store'} required={false}>
                <Radio.Group
                  onChange={e => this.onChange('status', e.target.value, false)}
                  defaultValue={productDetail.state.product.status}
                >
                  <Radio style={radioStyle} value={1}>
                    Display in catalog and sell
                  </Radio>
                  <Radio style={radioStyle} value={2}>
                    Display in catalog and do not sell
                  </Radio>
                  <Radio style={radioStyle} value={4}>
                    Display in catalog and do inquiry form
                  </Radio>
                  <Radio style={radioStyle} value={3}>
                    Hide from catalog
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Divider />
              <Suppliers>
                {({ suppliers }: any) => {
                  if (suppliers.loading) {
                    return (
                      <div>
                        <Spin /> Loading suppliers ...
                      </div>
                    );
                  }

                  return (
                    <div>
                      <Form.Item
                        validateStatus={this.validateStatus('supplier')}
                        help={this.validateMessage('supplier')}
                        required={true}
                        label={'Supplier'}
                      >
                        <Radio.Group
                          onChange={e => container.onChange('supplierId', e.target.value, false)}
                          defaultValue={(productDetail.state.product.supplier || {}).id}
                        >
                          {(suppliers.suppliers || []).map((s: GQL.ISupplier) => {
                            return (
                              <Radio key={s.id} style={radioStyle} value={s.id}>
                                {s.name}
                              </Radio>
                            );
                          })}
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  );
                }}
              </Suppliers>
            </Col>
          </Row>
        )}
      </Subscribe>
    );
  }

  private onChange(key: string, val: any, validate: boolean, language?: string) {
    this.props.container.onChange(key, val, validate, language);
  }

  private onChangeMany(pairs: Array<{ key: string; val: any; validate: boolean; language?: string }>) {
    this.props.container.onChangeMany(pairs);
  }

  private validateMessage(field: string) {
    const error = this.props.container.state.errors.generalSettings[field];
    const warning = this.props.container.state.warnings.generalSettings[field];

    if (error) {
      return error;
    }

    return warning;
  }

  private validateStatus(field: string) {
    const error = this.props.container.state.errors.generalSettings[field];
    const warning = this.props.container.state.warnings.generalSettings[field];

    if (error) {
      return 'error';
    }
    if (warning) {
      return 'warning';
    }

    return undefined;
  }

  private languageInputsStatus() {
    let valid = true;
    for (const key of Object.keys(this.props.container.state.warnings.generalSettings)) {
      if (this.props.container.state.warnings.generalSettings[key] != undefined) {
        // console.log(`returning false cause ${key} is not valid`, {
        //     stuff: this.props.container.state.warnings.generalSettings
        // });
        valid = false;
        break;
      }
    }

    if (valid) {
      return undefined;
    }

    return 'warning';
  }

  private calculatePrice(): number {
    return (this.props.container.state.product.price || 0) + (this.props.container.state.product.deliveryPriceAddition || 0);
  }

  private calculateVat(): number {
    if (!this.props.container.state.product.price || !this.props.container.state.product.VATrate) {
      return 0;
    }

    return Math.ceil((this.calculatePrice() / 100) * this.props.container.state.product.VATrate * 100) / 100;
  }

  private updateCategories(
    checked: { checked: Array<string> } | Array<string>,
    currentCategoriesIds: Array<GQL.ICategory>,
    allCategories: Array<GQL.ICategory>,
    eshopId: string
  ): void {

    const currentCategories = allCategories.filter((c: any) => {
      if (currentCategoriesIds) {
        if (currentCategoriesIds.find((cc: any) => cc.id === c.id)) {
          return true;
        }
      }

      return false;
    });

    const relevantCategories = (allCategories || []).filter(c => c.eshop.id.toString() === eshopId.toString());
    const otherCategories = (currentCategories || []).filter(c => {
      return c.eshop.id.toString() !== eshopId.toString()
    });

    const newCategories = relevantCategories.filter(category => {
      return (Array.isArray(checked) ? checked : checked.checked).indexOf(category.id.toString()) > -1;
    });

    this.props.container.onChange('categories', [...otherCategories, ...newCategories], false);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/GeneralSettingsTab/GeneralSettingsTab.tsx